import { gql } from "@apollo/client";

export const TOPIC_BASIC_FIELDS_FRAGMENT = gql`
  fragment TopicBasicFields on Topic {
    id
    title
    description
  }
`;

export const TOPIC_ADDITIONAL_FIELDS_FRAGMENT = gql`
  fragment TopicAdditionalFields on Topic {
    ...TopicBasicFields
    studyGoals
    additionalResources
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;
